export default __webpack_public_path__ + "static/media/Axis of Sickening Dreams.2c061ec1.jpg";